import AppRouter from "./router/AppRouter";
import { AuthProvider } from "./util/Auth";
import { TimezoneProvider } from "./contexts/TimezoneContext";

export default function App() {
  return (
    <AuthProvider>
      <TimezoneProvider>
        <AppRouter />
      </TimezoneProvider>
    </AuthProvider>
  );
}
